import { useQuery } from '@tanstack/react-query'

const request = async (endpoint: string) => {
    const res = await fetch(`/api/${endpoint}`, {
        headers: {
            Accept: 'application/vnd.org.internations.mobile.v1+json',
            'Content-Type': 'application/vnd.org.internations.mobile.v1+json',
        },
    })
    if (!res.ok) {
        throw new Error('Network response was not ok')
    }

    return res.json()
}

export const useCurrentUser = () => {
    return useQuery({
        queryKey: ['currentUser'],
        queryFn: () => request('users/current'),
    })
}
